import { pick, isEmpty } from 'lodash';
import { timestampToApiDate } from 'Utils/date/apiDate';
const ATTENDEE_SCHEMA_PROPERTIES = [
  'id',
  'lastName',
  'firstName',
  'unicodeLastName',
  'unicodeFirstName',
  'birthdate',
  'email',
  'mobile',
  'optinSms',
  'optinMail',
  'optinFosun',
  'optinEmail',
  'optinPhone',
  'optinClubmedPlus',
  'civility',
  'identityNumber',
  'healthPassId',
  'travelDocuments',
  'customerId',
  'address',
  'mainContactId',
  'isChild',
  'optinsCGU',
];

/**
 * Remove all properties that don't match GQL Schema Otherwise the mutation fails
 */
export const removeUselessProperties = (attendee: Adult | Kid) => {
  const travelDocuments = attendee.document
    ? Object.keys(attendee.document).reduce((fullDocuments, type) => {
        const document = attendee.document[type] || {};

        if (!isEmpty(document)) {
          const newDocument: Record<string, string | undefined> = {};

          // We fill all fields once we have a documentNumber
          if (document.documentNumber) {
            newDocument.document_number = document.documentNumber || undefined;
            newDocument.issuing_country = document?.issuingCountry || undefined;
            newDocument.birth_country = document?.birthCountry || undefined;
            newDocument.birth_city = document?.birthCity || undefined;
            newDocument.second_name = document?.secondName || undefined;
            newDocument.third_name = document?.thirdName || undefined;
            newDocument.fourth_name = document?.fourthName || undefined;
            newDocument.expiration_date = timestampToApiDate(document?.expirationDate) || undefined;
            newDocument.issuing_date = timestampToApiDate(document?.issuingDate) || undefined;
            newDocument.nationality = document.nationality || undefined;
            newDocument.type = document?.type || undefined;
          }

          if (!isEmpty(newDocument)) {
            fullDocuments.push(newDocument);
          }
        }

        return fullDocuments;
      }, [])
    : [];
  return pick(
    {
      ...attendee,
      travelDocuments,
      // keep customerId like this because we cannot update attendees for B2C
      customerId: attendee.neolid,
      birthdate: timestampToApiDate(attendee.birthdate as string | number),
    },
    ATTENDEE_SCHEMA_PROPERTIES,
  );
};
